import { Component, Vue, Prop, Inject, Watch } from 'vue-property-decorator';
import { RulesRunner } from "./FormSupport";
import ID from "../../ID";

export type Rule = (v: unknown) => true | string;

@Component
export default class InputMixin extends Vue implements RulesRunner {
    @Prop() value!: unknown;
    @Prop() id!: string | null;
    @Prop() rules!: Rule[];
    @Prop({ type: Boolean }) isError!: boolean;
    @Prop({ type: Boolean }) isRequired!: boolean;
    @Prop() errors!: string[];

    @Inject({ default: null }) readonly onFieldError?: (id: unknown, on: boolean) => void;
    @Inject({ default: null }) readonly notifyForm?: (id: string, fld?: RulesRunner) => void;

    protected ruleMessages: string[] = [];

    protected get myId(): string {
        return this.id || ID.next();
    }

    public get haveErrors(): boolean {
        return this.isError || this.allErrorMessages.length > 0;
    }

    public created() {
        if (this.notifyForm) {
            this.notifyForm(this.myId, this);
        }
    }

    public destroyed() {
        if (this.notifyForm) {
            this.notifyForm(this.myId);
        }
    }

    @Watch("haveErrors")
    private onErrorStatusChanged() {
        this.$emit("error-status", this.haveErrors);
    }

    protected get allErrorMessages(): string[] {
        const ret: string[] = [];
        if (this.errors) {
            ret.push(...this.errors);
        }
        ret.push(...this.ruleMessages);
        return ret;
    }

    public runRules(input?: unknown) {
        if (this.rules) {
            if (input === undefined) {
                input = this.value;
            }

            const wasRuleError = this.ruleMessages.length > 0;
            const messages: string[] = [];
            let val;
            for (const rule of this.rules) {
                val = rule(input);
                if (typeof val === 'string') {
                    messages.push(val);
                    break;
                }
            }

            this.ruleMessages = messages;
            const isRuleError = (this.ruleMessages.length > 0);
            if (wasRuleError !== isRuleError && this.onFieldError) {
                this.onFieldError(this.myId, isRuleError);
            }
        }
    }

}
